import { render, staticRenderFns } from "./ActivityTextContainer.vue?vue&type=template&id=2b1fc19a&scoped=true"
import script from "./ActivityTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityTextContainer.vue?vue&type=style&index=0&id=2b1fc19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fc19a",
  null
  
)

/* custom blocks */
import block0 from "./ActivityTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports